/* eslint react-hooks/exhaustive-deps: 0 */

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { authStateSelector } from './redux/features/auth/authSlice';
import UIRoutes from './routes';
import { socket } from './redux/services/webSocket';


function App() {
  const {user, tenantId} = useSelector(authStateSelector)

  //For Connecting Websocket
  useEffect(() => {
    if (!user?.userId || !tenantId) {
      return;
    }

    socket.auth = { userId: user.userId, tenantId };
    if (!socket.connected) {
      socket.connect();
    }

    const handleDisconnect = (reason: string) => {
      console.warn('[WebSocket] Disconnected', { reason });
    };

    socket.on('disconnect', handleDisconnect);

    return () => {
      socket.off('disconnect', handleDisconnect);
    };
  }, [user?.userId, tenantId])
  return (
     <UIRoutes />
  );
}

export default App;
